<span class="overline">GROUNDING SETTINGS</span>

<h3-view-settings-slider
  [settingStore]="groundingConfigurationStore('searchRadius')"
  [defaultValue]="defaultGroundingConfiguration.searchRadius"
  [config]="searchRadiusConfig"
  label="Search radius"
  settingName="grounding_search_radius"
  suffix="m"
>
</h3-view-settings-slider>

<div class="use-points-section">
  <span class="caption">Use points</span>
  <mat-button-toggle-group
    [nasModel]="groundingConfigurationStore('useAllPoints')"
    (change)="toggleUseAllPoints($event)"
  >
    <mat-button-toggle [value]="false">Ground points</mat-button-toggle>
    <mat-button-toggle [value]="true">All points</mat-button-toggle>
  </mat-button-toggle-group>
</div>
